import { IArticleVideo, IPage, IPageProps } from '../../types'
import { getParameterByName, setClientConfig } from '../../utils'
import { config } from '../../lib'
import fs from 'fs/promises'
import { GetStaticPaths, GetStaticProps, GetStaticPropsResult } from 'next'
import { api } from '../../lib/api'
import axios from 'axios'
import { Player } from '../../components/Player/Player'
import { Scripts } from '../../components/Scripts'
import { Providers } from '../../components/Providers'
import { EmbedWrapper } from '../../styles/GlobalStyle'
import Head from 'next/head'
import errorPage from '../[[...all]]'
import { useEffect, useState } from 'react'

const Embed = ({
  page,
  adTargetEnv,
  notFound = false,
  ...props
}: IPageProps) => {
  setClientConfig({
    page,
    adTargetEnv,
    notFound,
    ...props,
  })
  const [video, setVideo] = useState<null | IArticleVideo>()
  useEffect(() => {
    const tempVideo = page.Content.Item?.video || ({} as IArticleVideo)
    const ref = getParameterByName('ref')
    if (ref) {
      tempVideo.name = ref
    }
    const poster = getParameterByName('poster')
    if (poster) {
      tempVideo.poster = poster
    }
    const k_id = getParameterByName('k_id')
    if (k_id) {
      tempVideo.kalturaId = k_id
    }
    const duration = getParameterByName('duration')
    if (duration) {
      tempVideo.duration = parseInt(duration)
    }
    setVideo(tempVideo)
  }, [page.Content.Item?.video])

  return (
    <>
      <Head key={'head'}>
        <title>{page.SEO.title}</title>
      </Head>
      <Scripts page={page} playerEmbed />
      <Providers page={page}>
        <EmbedWrapper>
          {video && video.name ? (
            <Player img={''} pageMeta={page.PageMeta} video={video} />
          ) : (
            <div>missing video</div>
          )}
        </EmbedWrapper>
      </Providers>
    </>
  )
}

export default Embed

export const getStaticProps: GetStaticProps<IPageProps> = async context => {
  const path = (context.params?.all as string[]) ?? []
  // console.log('getStaticProps', path.join('/'), config)
  const dataQueryPath = `/${path.join('/')}/`
  let res: GetStaticPropsResult<IPageProps>
  const props = {
    googleTagManager: config.googleTagManager || 'GTM-W6ZR3W',
    googleAnalytics: config.googleAnalytics || 'UA-985873-3',
    kalturaPlayerId: config.kalturaPlayerId || '50272542',
    live_ima: config.live_ima,
    live_mid_rolls: config.live_mid_rolls,
    baseUrl: config.baseUrl,
    disableMetrics: config.disableMetrics || '0',
    dataQuerySource: config.dataQuerySource,
    geo_plugin_key: config.geo_plugin_key || '',
    login_page: config.login_page,
    bigBrotherRegistration: config.bigBrotherRegistration,
    shouldTaboolaWaitForInterstitial: config.shouldTaboolaWaitForInterstitial,
    alsoSkipSpecialRef: false,
    adblock_detection: config.adblock_detection,
  }
  try {
    const page = (await api.fetchPage(
      dataQueryPath,
      config.dataQuerySource
    )) as IPage

    if (!page.Content) {
      res = {
        props: {
          ...props,
          page,
          notFound: true,
        },
        revalidate: config.revalidateInSeconds,
      }
      return res
    }

    res = {
      props: {
        page,
        ...props,
        newsFlashQuerySource: config.newsFlashQuerySource,
        adTargetEnv: config.adTargetEnv || '',
      },
      revalidate: config.revalidateInSeconds,
    }
    return res
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    console.warn(
      'Error while fetching qdata for page',
      config.dataQuerySource,
      dataQueryPath,
      axios.isAxiosError(err) ? err.toJSON() : err
    )
    res = {
      props: {
        page: err?.response?.data || errorPage,
        ...props,
      },
      notFound: true,
      revalidate: config.revalidateInSeconds,
    }
    return res
  }
}

export const getStaticPaths: GetStaticPaths = async context => {
  console.log('getStaticPaths', context)
  let paths = [] as string[]
  if (config.prebuildPages) {
    const csv = await fs.readFile('./config/test-pages.csv', 'utf8')
    paths = csv
      .split(/\r?\n/g)
      .filter(t => !!t)
      .map(t => new URL(t).pathname)
  }
  return {
    paths,
    fallback: 'blocking',
  }
}
